import Component from 'vue-class-component';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import style from './style.vue';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';
import Upload from '@/views/components/upload/upload.vue';
import LinkForm from '@/views/components/linkForm/linkForm.vue';
import { globalElement } from '@/library/utils/globalElement';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils, getConditionText, setCondition } from '@/util';
import isset = QinggerLibUtils.isset;
import { EmpServiceAPIActions } from '@/services/empService';


@DialogFactory
@Component({
  components: {
    Upload,
    LinkForm,
  },
  mixins: [style],
})

export default class AddSiteAdd extends IPSDialog {
  sgId = '';

  siteId = '';

  id = '';

  corpId = '';

  classList: ItemArray;

  coupon: number;

  title = '';

  width = '600px';

  adName = '';

  value: ItemObject = {};

  data: OpenAdInfo = {
    showType: 4,
    fieldType: 'OpenScreenPropagate',
    desc: {},
  };
  linkInfo: OpenAdDesc = {};

  attributeList = [];

  footer = false;

  startTime = '';

  endTime = '';

  // advName = '';
  advPic = '';

  condition: any = {
    id: '',
    text: '',
  };
  receiptConfig: { type?: number; id?: string } = {
    type: 0,
    id: '',
  };
  tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  validateDate(v) {
    let curTime = 0;
    let startTime = 0;
    let endTime = 0;
    const newTime = new Date();
    if (this.endTime && this.startTime) {
      curTime = newTime.valueOf();
      startTime = new Date(this.startTime).valueOf();
      endTime = new Date(this.endTime).valueOf();
      if (endTime < startTime) {
        this.$message.error('有效期结束时间不能小于开始时间！');
        this.endTime = '';
        return;
      }
      if (endTime < curTime) {
        this.$message.error('有效期结束时间不能小于当前时刻！');
        this.endTime = '';
        return;
      }
      if (endTime === curTime) {
        this.$message.error('有效期结束时间不能为当前时刻！');
        this.endTime = '';
        return;
      }
    }
  }

  validateBegin(v) {
    const startTime = new Date(this.startTime).valueOf();
    const endTime = new Date(this.endTime).valueOf();
    if (startTime && endTime && (startTime > endTime)) {
      this.$message.error('有效期开始时间不能大于结束时间！');
      this.startTime = '';
      return;
    }
  }

  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.advPic = res.content;
  }

  save() {
    const desc = Object.assign({}, this.linkInfo, {
      advName: this.data.desc.advName,
      advPic: this.advPic,
      receiptConfig: this.receiptConfig,
      advBeginTime: new Date(this.startTime).valueOf() / 1000 || 0,
      advEndTime: new Date(this.endTime).valueOf() / 1000 || 0,
    });
    const postParams = Object.assign({}, this.data, { desc }, { siteId: this.siteId });
    if (!postParams.desc.advName) {
      this.$message.warning('请输入广告名称');
      return;
    }
    if (!postParams.desc.advPic) {
      this.$message.warning('请上传图片');
      return;
    }
    if (this.linkInfo.linkType === 12) {
      if (!this.linkInfo.couponInfo.couponCover) {
        this.$message.warning('请上传优惠券图片');
        return;
      }
      if (!this.linkInfo.couponInfo.points) {
        this.$message.warning('请填写优惠券价格');
        return;
      }
    }
    IPSService.siteOpenAdvSave({ postParams }).then((res) => {
      if (res.result) {
        this.$message.success(this.id ? '修改成功！' : '新增成功！');
        this.$emit('result', true);
        this.$emit('hidden');
      }
    });
  }

  getData() {
    IPSService.siteOpenAdvInfo({
      postParams: {
        siteId: this.siteId,
        ygswpId: this.id,
        corpId: this.corpId,
      },
    }).then(async (res: OpenAdInfo) => {
      this.data = Object.assign({}, this.data, { ...res, advName: this.adName });
      this.linkInfo = cloneDeep(this.data.desc || {});
      // this.advName = this.linkInfo?.advName ? this.linkInfo?.advName : this.adName;
      this.advPic = this.linkInfo.advPic;
      this.receiptConfig = Object.assign({}, this.receiptConfig, { ...this.linkInfo?.receiptConfig });
      this.condition.id = this.receiptConfig?.id||'';
      this.condition.text = await getConditionText(this.condition.id, this.siteId);
      this.startTime = this.linkInfo.advBeginTime ? moment(this.linkInfo.advBeginTime * 1000).format('YYYY-MM-DD HH:mm') : '';
      this.endTime = this.linkInfo.advEndTime ? moment(this.linkInfo.advEndTime * 1000).format('YYYY-MM-DD HH:mm') : '';
    });
  }

  /**
   * 获取关联分类
   */
  public getAttributeList(): Promise<any> {
    return IPSService.getAttributeList().then((res) => {
      return isset(res, 'list') ? res.list : [];
    });
  }

  /**
   * 根据筛选条件
   */
  setCondition(e) {
    const params = {
      siteId: this.siteId, sgId: this.sgId, id: this.condition.id,
    };
    e.stopPropagation();
    setCondition(params).then((r: any) => {
      this.condition = r;
      this.receiptConfig.type = 1;
      this.receiptConfig.id = r.id;
    });
  }

  async mounted() {
    this.attributeList = await this.getAttributeList();
    this.id && this.getData();
  }

  onLinkChange(val) {
    this.linkInfo = val;
  }

  clearCondition() {
    this.condition = {};
    this.receiptConfig.id = '';
    this.receiptConfig.type = 0;
  }

  renderFooter(h) {
    return (
      <div class="bottomWrapper row items-center justify-end r-py-12 r-pr-12" style="border-top: 1px solid #EBEEF5">
        <el-button type="cancel" onClick={() => this.onCancel()}>
          取消
        </el-button>
        <el-button type="primary" onClick={() => this.save()}>
          确定
        </el-button>
      </div>
    );
  }


  renderContent(h) {
    return (
      <div>
        <div class="r-pa-20">
          <el-form props={{ model: this.data.desc }} ref="form" label-position="left" label-width="80px">
            <el-form-item label="广告名称" prop="advName" rules={[{ required: true, message: '请输入广告名称', trigger: 'blur' }]}
            >
              <el-input v-model={this.data.desc.advName} maxlength={10} />
            </el-form-item>
            <el-form-item label="广告图片" prop="advPic">
              <Upload onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.advPic} noDelete={false}
                      maxSize={2048}
              />
            </el-form-item>
            <el-form-item label="可见会员" prop="receiptConfig">
              <div class="condition-selected row items-center" onClick={e => this.setCondition(e)}>
                {this.condition.text ? (
                  <el-tag class="tag" closable onClose={() => {
                    this.clearCondition();
                  }}
                  >
                    {this.condition.text}
                  </el-tag>
                ) : (
                  <span class="placeholder">
                      请设置顾客参与门槛
                    </span>
                )}
                <i class="iconfont iconshaixuan1" />
              </div>
              <p class="tip line-height-4 r-mt-16"><span class="text-red r-pr-2">*</span> 不配置则对所有人可见</p>
            </el-form-item>
            <el-form-item label="有效期" className="datepicker">
              <el-date-picker v-model={this.startTime} onChange={this.validateBegin.bind(this)}
                              format={'yyyy-MM-dd HH:mm:ss'} type="datetime"
              />
              <span class="font-size-14 r-mx-8 ">至</span>
              <el-date-picker v-model={this.endTime} onChange={this.validateDate.bind(this)}
                              format={'yyyy-MM-dd HH:mm:ss'} type="datetime"
              />
              <p class="tip line-height-4 r-mt-10"><span class="text-red r-pr-2">*</span>不填写则长期有效</p>
            </el-form-item>
            <LinkForm
              attributeList={this.attributeList.map((v) => {
                v.value_name = v.attrName;
                v.value_no = v.attrCode;
                v.class_code = v.attrCode;
                v.isLeafe = !v.list || !v.list.length;
                return v;
              })}
              empCode={+globalElement.Vm.$store.state.empCode}
              state={1}
              sgId={+globalElement.Vm.$route.params.sgId}
              siteCodes={[globalElement.Vm.$route.params.code]}
              v-model={this.linkInfo}
              mode={2}
              siteId={this.siteId}
              goodsClassList={this.classList}
              hotarea={false}
              hotAd={false}
              sortShow={true}
              dialogFooter={false}
              labelWidth={'80px'}
              onChange={this.onLinkChange.bind(this)}
              exclude={this.coupon ? [7, 8, 14, 15, 16] : [7, 8, 12, 14, 15, 16]}
              ref="linkForm"
            />
          </el-form>
        </div>
        {this.renderFooter(h)}
      </div>
    );
  }
}
